import { EnvironmentType } from './enums';

export interface EnvironmentConfig {
  type: EnvironmentType;
  adminApiServiceBaseUri: string;
}
